import { CartAddEvent } from '@theme/events';

/**
 * When the cart type is set to "page" (i.e. there is no cart drawer), redirect
 * the customer to the cart page right after an item is successfully added to
 * the cart. This mirrors the behaviour of the cart drawer auto-opening.
 */
document.addEventListener(CartAddEvent.eventName, (event) => {
  // `CartAddEvent` shares its event name with `CartUpdateEvent`, so make sure
  // this is an actual add-to-cart action and that it didn't fail.
  if (!(event instanceof CartAddEvent)) return;
  if (event.detail?.data?.didError) return;

  const cartUrl = (typeof Theme !== 'undefined' && Theme.routes?.cart_url) || '/cart';
  window.location.assign(cartUrl);
});
